import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Alarm, AlarmInbox, AlarmStatus, Alert, InboxAlarm, UnreadCount, UpsertAlertPayload } from '../models/alert.model';

@Injectable({
  providedIn: 'root',
})
export class AlertsApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiUrl;

  listAlerts(): Observable<Alert[]> {
    return this.http.get<Alert[]>(`${this.baseUrl}/alerts`);
  }

  createAlert(payload: UpsertAlertPayload): Observable<Alert> {
    return this.http.post<Alert>(`${this.baseUrl}/alerts`, payload);
  }

  updateAlert(id: string, payload: UpsertAlertPayload): Observable<Alert> {
    return this.http.patch<Alert>(`${this.baseUrl}/alerts/${id}`, payload);
  }

  setAlertEnabled(id: string, enabled: boolean): Observable<Alert> {
    return this.http.patch<Alert>(`${this.baseUrl}/alerts/${id}/enabled`, { enabled });
  }

  deleteAlert(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/alerts/${id}`);
  }

  listAlarms(status?: AlarmStatus): Observable<Alarm[]> {
    const params = status ? new HttpParams().set('status', status) : undefined;
    return this.http.get<Alarm[]>(`${this.baseUrl}/alarms`, { params });
  }

  resolveAlarm(id: string, resolutionNote: string): Observable<Alarm> {
    return this.http.post<Alarm>(`${this.baseUrl}/alarms/${id}/resolve`, {
      resolution_note: resolutionNote,
    });
  }

  getInbox(): Observable<AlarmInbox> {
    return this.http.get<AlarmInbox>(`${this.baseUrl}/alarms/inbox`);
  }

  unreadCount(): Observable<UnreadCount> {
    return this.http.get<UnreadCount>(`${this.baseUrl}/alarms/unread-count`);
  }

  markAlarmRead(id: string): Observable<InboxAlarm> {
    return this.http.post<InboxAlarm>(`${this.baseUrl}/alarms/${id}/read`, {});
  }

  markAllAlarmsRead(): Observable<UnreadCount> {
    return this.http.post<UnreadCount>(`${this.baseUrl}/alarms/read-all`, {});
  }
}
